import { tbGraphics } from "./tbGraphics";
import { tbMath } from "./tbMath";
var tbVector = /** @class */ (function () {
    function tbVector(x, y) {
        this.x = x;
        this.y = y;
    }
    tbVector.tbVectorFromPolar = function (direction, length) {
        var x = length * Math.cos(tbMath.degToRad(direction));
        var y = -length * Math.sin(tbMath.degToRad(direction));
        return new tbVector(x, y);
    };
    tbVector.prototype.assignVector = function (point) {
        this.x = point.x;
        this.y = point.y;
    };
    tbVector.prototype.assignXY = function (x, y) {
        this.x = x;
        this.y = y;
    };
    tbVector.prototype.assign = function (vector_or_x, undefined_or_y) {
        if (undefined_or_y === undefined) {
            this.x = vector_or_x.x;
            this.y = vector_or_x.y;
        }
        else {
            this.x = vector_or_x;
            this.y = undefined_or_y;
        }
    };
    tbVector.prototype.magnitude = function () {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    tbVector.prototype.length = function () {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    tbVector.prototype.lengthSquared = function () {
        return this.x * this.x + this.y * this.y;
    };
    tbVector.prototype.distanceSquared = function (other) {
        var dx = (this.x - other.x), dy = (this.y - other.y);
        return dx * dx + dy * dy;
    };
    tbVector.prototype.distance = function (other) {
        var dx = (this.x - other.x), dy = (this.y - other.y);
        return Math.sqrt(dx * dx + dy * dy);
    };
    tbVector.prototype.distanceSquaredXY = function (x, y) {
        var dx = (this.x - x), dy = (this.y - y);
        return dx * dx + dy * dy;
    };
    tbVector.prototype.distanceXY = function (x, y) {
        var dx = (this.x - x), dy = (this.y - y);
        return Math.sqrt(dx * dx + dy * dy);
    };
    tbVector.prototype.direction = function () {
        return tbMath.radToDeg(Math.atan2(-this.y, this.x));
    };
    tbVector.prototype.clone = function () {
        return new tbVector(this.x, this.y);
    };
    tbVector.prototype.add = function (vector) {
        return new tbVector(this.x + vector.x, this.y + vector.y);
    };
    tbVector.prototype.addDirect = function (vector) {
        this.x += vector.x;
        this.y += vector.y;
    };
    tbVector.prototype.subtract = function (vector) {
        return new tbVector(this.x - vector.x, this.y - vector.y);
    };
    tbVector.prototype.subtractDirect = function (vector) {
        this.x -= vector.x;
        this.y -= vector.y;
    };
    tbVector.prototype.negate = function () {
        return new tbVector(-this.x, -this.y);
    };
    tbVector.prototype.negateDirect = function () {
        this.x = -this.x;
        this.y = -this.y;
    };
    tbVector.prototype.scale = function (scalar) {
        return new tbVector(scalar * this.x, scalar * this.y);
    };
    tbVector.prototype.scaleDirect = function (scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    tbVector.prototype.multiply = function (vector) {
        return new tbVector(vector.x * this.x, vector.y * this.y);
    };
    tbVector.prototype.multiplyDirect = function (vector) {
        this.x *= vector.x;
        this.y *= vector.y;
    };
    tbVector.prototype.rotate = function (angle) {
        var s = Math.sin(angle * Math.PI / 180), c = Math.cos(angle * Math.PI / 180);
        return new tbVector(c * this.x + s * this.y, -s * this.x + c * this.y);
    };
    tbVector.prototype.rotateDirect = function (angle) {
        var s = Math.sin(angle * Math.PI / 180), c = Math.cos(angle * Math.PI / 180), x = this.x;
        this.x = c * this.x + s * this.y;
        this.y = -s * x + c * this.y;
    };
    tbVector.prototype.dot = function (vector) {
        return (this.x * vector.x + this.y * vector.y);
    };
    tbVector.prototype.perpendicular = function () {
        return new tbVector(this.y, -this.x);
    };
    tbVector.prototype.perpendicularDirect = function () {
        var x = this.x;
        this.x = this.y;
        this.y = -x;
    };
    tbVector.prototype.normalize = function () {
        var m = this.magnitude();
        if (m === 0) {
            return new tbVector(0, 0);
        }
        return new tbVector(this.x / m, this.y / m);
    };
    tbVector.prototype.normalizeDirect = function () {
        var m = this.magnitude();
        if (m === 0) {
            this.x = 0;
            this.y = 0;
            return;
        }
        this.x /= m;
        this.y /= m;
    };
    tbVector.prototype.normal = function () {
        return (this.perpendicular()).normalize();
    };
    tbVector.prototype.normalDirect = function () {
        this.perpendicularDirect();
        this.normalizeDirect();
    };
    tbVector.prototype.draw = function (x, y, color) {
        var sc = Math.min(8, this.length() / 4), vec1 = this.subtract(this.normalize().scale(2 * sc)), vec2 = vec1.add(this.normal().scale(sc)), vec3 = vec1.add(this.normal().scale(-sc)), context = tbGraphics.context;
        context.strokeStyle = color;
        context.beginPath();
        context.moveTo(x, y);
        context.lineTo(x + vec1.x, y + vec1.y);
        context.lineTo(x + vec2.x, y + vec2.y);
        context.lineTo(x + this.x, y + this.y);
        context.lineTo(x + vec3.x, y + vec3.y);
        context.lineTo(x + vec1.x, y + vec1.y);
        context.stroke();
    };
    return tbVector;
}());
export { tbVector };
